/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ScopesControllerBulkMoveMutationRequest, ScopesControllerBulkMoveMutationResponse, ScopesControllerBulkMove400, ScopesControllerBulkMove401 } from "../../models/scopesController/ScopesControllerBulkMove";

function getScopesControllerBulkMoveUrl() {
  const res = { method: 'PATCH', url: `/api/v1/scopes/bulk` as const }  
  return res
}

/**
 * @description Move multiple scopes (files/folders/projects) to a new parent scope in a single call. Supports partial success - if some items fail, the successful ones are still moved. Returns 200 if all items succeed, 207 Multi-Status if some items fail.
 * @summary Bulk move scopes
 * {@link /api/v1/scopes/bulk}
 */
export async function scopesControllerBulkMove(data: ScopesControllerBulkMoveMutationRequest, config: Partial<RequestConfig<ScopesControllerBulkMoveMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ScopesControllerBulkMoveMutationResponse, ResponseErrorConfig<ScopesControllerBulkMove400 | ScopesControllerBulkMove401>, ScopesControllerBulkMoveMutationRequest>({ method : "PATCH", url : getScopesControllerBulkMoveUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}